import React from 'react';
import './Header.css';

function Header() {
  return (
    <div className="header">
      <h2>notes+maker</h2>
    </div>
  );
}

export default Header;
